import { ExpandIcon, WorldIcon } from "../Icons";
import { Typo } from "../Typo";
import type { GetLanguageLabel } from "./types";

export const DetailsCell = ({
  bannerGroup,
  width,
  height,
  language,
  getLanguageLabel,
}: {
  bannerGroup: string;
  width: number;
  height: number;
  language: string;
  /** Resolves the language code to a display label (locale-aware, injected). */
  getLanguageLabel: GetLanguageLabel;
}) => {
  const dimensions = `${width}×${height}`;
  const languageLabel = getLanguageLabel(language.trim() || "en");

  return (
    <div className="flex h-[80px] flex-col justify-center gap-1 p-4">
      <Typo type="bodyMD" className="truncate">
        {bannerGroup}
      </Typo>
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1 w-20">
          <ExpandIcon
            className="[&_path]:stroke-icon-tertiary"
            width={16}
            height={16}
          />
          <Typo type="bodySM" textColor="text-text-secondary">
            {dimensions}
          </Typo>
        </div>
        <div className="flex items-center gap-1">
          <WorldIcon
            className="[&_path]:stroke-icon-tertiary"
            width={16}
            height={16}
          />
          <Typo type="bodySM" textColor="text-text-secondary">
            {languageLabel}
          </Typo>
        </div>
      </div>
    </div>
  );
};
